import { createReducer } from "@reduxjs/toolkit";
import type { TeacherPayoutVM } from "@shared-kernel/application/ports/teacher/teacher-repository";
import { teacherRetrievePayouts } from "./retrieve-teacher-payouts";
import type { RetrievalState } from "@redux/state/shared-types";

const initialState: RetrievalState<TeacherPayoutVM[]> = {
  fetching: "idle",
  data: [],
};

export const teacherRetrievePayoutsReducer = createReducer(initialState, builder => {
  builder
    .addCase(teacherRetrievePayouts.pending, state => {
      state.fetching = "pending";
    })
    .addCase(teacherRetrievePayouts.fulfilled, (state, action) => {
      state.fetching = "success";
      state.data = action.payload;
    })
    .addCase(teacherRetrievePayouts.rejected, state => {
      state.fetching = "failed";
    });
});
